import cuid from "cuid";
import { getFirestore } from "redux-firestore";
import { history } from "@austere-monorepo/components";

export const handleFormAdd = ({ auth, formCollection, formData, redirect }) => {
  const firestore = getFirestore();
  const docID = cuid();
  return async (dispatch) => {
    dispatch({
      type: "ENQUEUE_SNACKBAR",
      notification: {
        message: "Saving item",
        options: {
          variant: "info"
        }
      }
    });
    try {
      await firestore.disableNetwork().then(() => {
        firestore.set(
          { collection: formCollection, doc: docID },
          {
            ...formData,
            created_at: Date.now(),
            created_by: auth.uid,
            created_by_name: auth.displayName,
            id: docID
          },
          { merge: true }
        );
      });
      await firestore.enableNetwork().then(() => {
        dispatch({
          type: "ENQUEUE_SNACKBAR",
          notification: {
            key: new Date().getTime() + Math.random(),
            message: "Item saved",
            options: {
              variant: "success"
            }
          }
        });
      });
      await history.push(redirect);
    } catch (e) {
      dispatch({
        type: "ENQUEUE_SNACKBAR",
        notification: {
          key: new Date().getTime() + Math.random(),
          message: "Item save failed" + e,
          options: {
            variant: "error"
          }
        }
      });
    }
  };
};

export const handleFormEdit = ({ auth, formCollection, formData, currentData, redirect }) => {
  const firestore = getFirestore();
  return async (dispatch) => {
    dispatch({
      type: "ENQUEUE_SNACKBAR",
      notification: {
        key: new Date().getTime() + Math.random(),
        message: "Updating item",
        options: {
          variant: "info"
        }
      }
    });
    try {
      await firestore.disableNetwork().then(() => {
        firestore.update(
          { collection: formCollection, doc: currentData.id },
          {
            ...formData,
            updated_at: new Date().getTime(),
            updated_by: auth.uid,
            updated_by_name: auth.displayName
          }
        );
      });
      await firestore.enableNetwork().then(() => {
        dispatch({
          type: "ENQUEUE_SNACKBAR",
          notification: {
            key: new Date().getTime() + Math.random(),
            message: "Item updated",
            options: {
              variant: "success"
            }
          }
        });
      });
      await history.push(redirect);
    } catch (e) {
      dispatch({
        type: "ENQUEUE_SNACKBAR",
        notification: {
          key: new Date().getTime() + Math.random(),
          message: "Item update failed " + e.message,
          options: {
            variant: "error"
          }
        }
      });
    }
  };
};

export const handleFormDelete = ({ formCollection, formData, redirect }) => {
  const firestore = getFirestore();
  console.log(formCollection);
  console.log(formData);
  return async (dispatch) => {
    dispatch({
      type: "ENQUEUE_SNACKBAR",
      notification: {
        key: new Date().getTime() + Math.random(),
        message: "Deleting item",
        options: {
          variant: "info"
        }
      }
    });
    try {
      await firestore.disableNetwork().then(() => {
        firestore.delete({
          collection: formCollection,
          doc: formData.id
        });
      });
      await firestore.enableNetwork().then(() => {
        dispatch({
          type: "ENQUEUE_SNACKBAR",
          notification: {
            key: new Date().getTime() + Math.random(),
            message: "Item deleted",
            options: {
              variant: "warning"
            }
          }
        });
      });
      await history.push(redirect);
    } catch (e) {
      dispatch({
        type: "ENQUEUE_SNACKBAR",
        notification: {
          key: new Date().getTime() + Math.random(),
          message: "Item delete failed " + e.message,
          options: {
            variant: "error"
          }
        }
      });
    }
  };
};
